<template>
	<div class="topInfo" :class="{ topInfoOther: loanColor == 'white' }">
		<span>LuckyPlata</span>
		<template v-if="loanColor == 'white'">
			<img
				src="@/assets/image/internal/messageWhite.webp"
				alt=""
				v-if="loanInfo.is_have_unread == 1"
				@click="gettoMessageCenter"
			/>
			<img src="@/assets/image/internal/messageWhite_other.webp" alt="" v-else @click="gettoMessageCenter" />
		</template>
		<template v-else>
			<img
				src="@/assets/image/internal/message.webp"
				alt=""
				v-if="loanInfo.is_have_unread == 1"
				@click="gettoMessageCenter"
			/>
			<img src="@/assets/image/internal/message_other.webp" alt="" v-else @click="gettoMessageCenter" />
		</template>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		props: {
			loanInfo: Object,
			loanColor: String,
		},
		created() {},
		mounted() {},
		methods: {
			gettoMessageCenter() {
				window.android.gettoMessageCenter()
			},
		},
	}
</script>
<style lang="scss" scoped>
	.topInfo {
		font-size: 0.4rem;
		font-family: PingFang-SC-Bold, PingFang-SC;
		font-weight: bold;
		color: #ffffff;
		padding: 0.2rem 0;
		display: flex;
		justify-content: space-between;
		img {
			width: 0.58rem;
		}
	}
	.topInfoOther {
		color: #fff;
	}
</style>
